// This import loads the firebase namespace along with all its type information.
import Notification from './notification-model'

export async function load_notifications(): Promise<Notification[]> {
  throw 'Not implemented'
}

export async function delete_notification(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_notification(): Promise<Notification> {
  throw 'Not implemented'
}
